<v-app><v-main><router-view></router-view></v-main></v-app>